// Multiline text support
export const transformMultiline = (value: string | React.ReactNode): string | React.ReactNode => {
  return typeof value !== 'string'
    ? value
    : value
        .split('\n')
        .map((line, i) => (line.length > 0 ? <div key={i}>{line}</div> : <br key={i} />))
}
